import * as React from 'react'
import { View, StyleSheet } from 'react-native'
import { dotGray } from '@themes/Colors'

export function Line({ noMargin }: { noMargin?: boolean }) {
  const marginVertical = noMargin ? 0 : 10
  return <View style={[styles.line, { marginVertical }]} />
}

const styles = StyleSheet.create({
  line: {
    borderColor: dotGray,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
})
